import { useState, useEffect } from "react";
import  client  from "../client/api";
import { ClientSession } from "../client/clientSession";
import CONSTANTS from "../constants";
import history from '../routes/helper/history'
import getUser from "./getUserFromToken";


const AuthProvider = () => {
    const [auth, setAuth] = useState(false);
    const [userSession, setUserSession] = useState({})
    const [loading, setLoading] = useState(true);
    const [errorResponse, setError] = useState(false);
    const [globlalMessage, setGlobalMessage] = useState([])
    const handleLogin = async ({email, password}, href) => {
            const { data } = await client.post(CONSTANTS.API.LOGIN, { 
                username: email,
                password,
                grantType: "accessToken"
            })
            

            ClientSession.userToken = data.accessToken


            client.defaults.headers.authorization = `Bearer ${data.accessToken}`;

            ClientSession.user = await getUser()
            
            setUserSession(ClientSession.user)

            setAuth(true)

            if (!ClientSession.user.profileId)  href = CONSTANTS.APP.PROFILE
            else if (!href) href = CONSTANTS.APP.HOME_PAGE

           /* redirect default */ history.push(href)
    }

    const handleLogout = () => {
        ClientSession.logout()
        client.defaults.headers.authorization = undefined;
        setAuth(false)
        setUserSession({})
        history.push("/")
    }

    useEffect(() => {
        const token = ClientSession.userToken

        if (token) {
            client.defaults.authorization = `Bearer ${token}`
            setAuth(true)
            setUserSession(ClientSession.user)
        }

        setLoading(false)

    }, [])
    return {
        handleLogin,
        handleLogout,
        setLoading,
        setUserSession,
        user: userSession,
        auth,
        loading,
        errorResponse,
        globlalMessage
    }
}

export default AuthProvider